import AdvantageItem from './advantage-item';

export default AdvantageItem;